import React, { useState } from 'react';
import { CircularProgress, Backdrop } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
  backdrop:{
      zIndex: 2,
      color: '#FFF'
  }
}));

export const useLoadingSpinner = () => {
  const [open, setOpen] = useState(false);
  const classes = useStyles();

  const LoadingSpinner = () => (
      <Backdrop
        className={classes.backdrop}
        open={open}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
  )

  const setSpinner = (bool) => {console.log('spinner: ' + bool); setOpen(bool)};

  return [
      LoadingSpinner,
      setSpinner
  ]
  ;
}